import React from "react";
import classNames from "classnames";
import { HEADING } from "../../classes";
function htmlElement(tagName, tagClassName) {
  return (props) => {
    const { className, elementRef, ...htmlProps } = props;
    return React.createElement(tagName, {
      ...htmlProps,
      className: classNames(tagClassName, className),
      ref: elementRef,
    });
  };
}

export const H1 = htmlElement("h1", HEADING);
export const H2 = htmlElement("h2", HEADING);
export const H3 = htmlElement("h3", HEADING);
export const H4 = htmlElement("h4", HEADING);
export const H5 = htmlElement("h5", HEADING);
export const H6 = htmlElement("h6", HEADING);
